// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_paperChamadaForm__F8fFr {
  padding: 0.7rem !important;
  background-color: #18316e !important;
  border-radius: 0.5rem !important;
}

.styles_iconeVerEditar__nNrqB {
  color: #fff !important;
}

.styles_iconeVerEditar__nNrqB:hover {
  background-color: rgba(255, 255, 255, 0.3) !important;
  border-radius: 50% !important;
}

@media (max-width: 425px) {
  .styles_paperChamadaForm__F8fFr {
    width: 15rem !important;
    margin: 0.7rem !important;
  }

  .styles_textoChamadaForm__bvK-p {
    font-size: 0.9rem !important;
  }

  .styles_iconeVerEditar__nNrqB {
    color: #fff !important;
    font-size: 1rem !important;
  }
}

@media (min-width: 426px) {
  .styles_paperChamadaForm__F8fFr {
    width: 24rem !important;
  }
  .styles_iconeVerEditar__nNrqB {
    margin: 0 0.5rem 0 0 !important;
    padding: 0.15rem !important;
  }
}

.styles_textoChamadaForm__bvK-p {
  padding: 0.5rem 1rem 0.5rem 0.5rem !important;
  font-family: "Inter" !important;
  text-align: start !important;
  justify-content: start !important;
  color: #fff !important;
  font-weight: 500 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/DashboardDados/styles.module.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qDAAqD;EACrD,6BAA6B;AAC/B;;AAEA;EACE;IACE,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,+BAA+B;IAC/B,2BAA2B;EAC7B;AACF;;AAEA;EACE,6CAA6C;EAC7C,+BAA+B;EAC/B,4BAA4B;EAC5B,iCAAiC;EACjC,sBAAsB;EACtB,2BAA2B;AAC7B","sourcesContent":[".paperChamadaForm {\n  padding: 0.7rem !important;\n  background-color: #18316e !important;\n  border-radius: 0.5rem !important;\n}\n\n.iconeVerEditar {\n  color: #fff !important;\n}\n\n.iconeVerEditar:hover {\n  background-color: rgba(255, 255, 255, 0.3) !important;\n  border-radius: 50% !important;\n}\n\n@media (max-width: 425px) {\n  .paperChamadaForm {\n    width: 15rem !important;\n    margin: 0.7rem !important;\n  }\n\n  .textoChamadaForm {\n    font-size: 0.9rem !important;\n  }\n\n  .iconeVerEditar {\n    color: #fff !important;\n    font-size: 1rem !important;\n  }\n}\n\n@media (min-width: 426px) {\n  .paperChamadaForm {\n    width: 24rem !important;\n  }\n  .iconeVerEditar {\n    margin: 0 0.5rem 0 0 !important;\n    padding: 0.15rem !important;\n  }\n}\n\n.textoChamadaForm {\n  padding: 0.5rem 1rem 0.5rem 0.5rem !important;\n  font-family: \"Inter\" !important;\n  text-align: start !important;\n  justify-content: start !important;\n  color: #fff !important;\n  font-weight: 500 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paperChamadaForm": `styles_paperChamadaForm__F8fFr`,
	"iconeVerEditar": `styles_iconeVerEditar__nNrqB`,
	"textoChamadaForm": `styles_textoChamadaForm__bvK-p`
};
export default ___CSS_LOADER_EXPORT___;
